<template>
  <div class="container">
    <b-navbar toggleable="lg" type="dark" variant="success">
      <b-navbar-brand href="#">空蝉</b-navbar-brand>
    </b-navbar>
    <div id='firebaseui-auth-container'></div>
    <p class="text-center">東大かるた会専用です。</p>
    <hr>
  </div>
</template>
<style>

</style>

<script>
import firebase from 'firebase/app'
import'firebase/auth'

// import router from '../router'

// FirebaseUI読み込み
import firebaseui from 'firebaseui-ja'
import 'firebaseui-ja/dist/firebaseui.css'

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      showError: false
    }
  },

  mounted() {
    // 認証設定
    const uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function() {
          // 認証種類判定
          return true;
        }
      },
      // 認証時に同一ウィンドウで表示
      signInFlow: 'redirect',
      // ログイン後リダイレクト先
      signInSuccessUrl: '/records',
      // 各認証
      signInOptions: [
        // firebase.auth.emailAuthProvider.PROVIDER_ID,
        // Google認証
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      ],
      // 利用規約へリンク
      // tosUrl: '/termsofuse',
      // プライバシーポリシーリンク
      // privacyPolicyUrl: '/privacypolicy'
    };

    // 認証UI表示
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    ui.start('#firebaseui-auth-container', uiConfig);
  },
}
</script>
